import App from 'app/app.js';

function StatesService(TranslateProviderService, ContentStore) {
  var US_CODE = 'US';
  var CA_CODE = 'CA';
  this.statesProvinces = ContentStore.getEnum('StateProvince').values;

  /**
   * If in the Canada domain it returns Provinces followed by states. If in the US Domain it returns states
   * then provinces. Both sorted in alphabetical order.
   * @returns {*}
   */
  this.getStates = function () {
    if (TranslateProviderService.isCanadianDomain()) {
      return this.getCanadianProvinces().concat(this.getAmericanStates());
    } else {
      return this.getAmericanStates().concat(this.getCanadianProvinces());
    }
  };

  /**
   * Filter through stateProvinces where the country is Canadian Provinces and return an array of provinces in
   * alphabetical order.
   * @returns {*}
   */
  this.getCanadianProvinces = function () {
    if (!!this.statesProvinces) {
      var ca = R.filter(function (province) {
        return province.country === CA_CODE;
      })(this.statesProvinces);

      return R.sortBy(R.prop('description'), ca);
    }
  };

  /**
   * Filter through stateProvinces where the country is US states and return an array of states in alphabetical
   * order.
   * @returns {*}
   */
  this.getAmericanStates = function () {
    if (!!this.statesProvinces) {
      var us = R.filter(function (state) {
        return state.country === US_CODE;
      })(this.statesProvinces);

      return R.sortBy(R.prop('description'), us);
    }
  };

  this.getAmericanCountryCode = function () {
    return US_CODE;
  };

  this.getCanadianCountryCode = function () {
    return CA_CODE;
  };
}

App.service('StatesService', ['TranslateProviderService', 'ContentStore', StatesService]);
